"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate } from "react-router-dom";
import {OnlyImageBgCard, PaveScaleCard} from "@/components/common/pave-scale-card";
import HeaderEspacePro from "@/components/espace-pro/header-espace-pro";
import FooterSiteOfficiel from "@/components/site-officiel/footer-site-officiel";

export default function Home() {
  const navigate = useNavigate();

  return (
      <main>
        <HeaderEspacePro />
          <div className={"flex flex-col gap-6 pb-6 mt-8"}>


          {/* Nature & Biodiversité */}
          <SectionPage sectionType="lg">

            <div className="text-center text-3xl font-bold text-bleu-ciel font-exo-bold mb-8">
              « AGIR ENSEMBLE POUR LE TOURISME DE DEMAIN »
            </div>


            <p className={"text-normal"}>
              Vous êtes un socio-professionnel ? <br/>
              Bienvenue sur l’espace pro de l’Office de Tourisme de la Côte d’Ivoire qui vous est dédié. Vous aurez accès à notre vision globale, à nos principales actions et y trouverez les informations et bonnes pratiques utiles au développement de votre entreprise. <br/>
              Un panel d’outils, de services et d’accompagnements vous y est proposé pour vous aider au quotidien. <br/>
              Promouvoir, animer, fédérer, développer, etc, Côte d’Ivoire Tourisme le fait avec vous chers partenaires/socio-professionnels/ pour réinventer la destination Côte d’Ivoire.

            </p>

          </SectionPage>

          <SectionPage sectionType="lg">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6 mb-6">
              <PaveScaleCard title={"L'Office de Tourisme"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/office-de-tourisme" titleClassName={"font-playfair-display italic font-bold"} />
              <OnlyImageBgCard imageSrc={"/images/espace-pro/accueil1.jpg"} className={"h-[400px]"} />
              <PaveScaleCard title={"Pôle de l'Observation et des Etudes"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/pole-observation-etudes" titleClassName={"font-playfair-display italic font-bold"} />
              <PaveScaleCard title={"L'Office et Vous"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/office-et-vous" titleClassName={"font-playfair-display italic font-bold"} />
              <OnlyImageBgCard imageSrc={"/images/espace-pro/accueil2.jpg"} className={"h-[400px]"} />
              <PaveScaleCard title={"Devenir Partenaire"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/devenir-partenaire" titleClassName={"font-playfair-display italic font-bold"} />
              <div></div>
              <PaveScaleCard title={"Promotion"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/promotion" titleClassName={"font-playfair-display italic font-bold"} />
              <div></div>
            </div>
          </SectionPage>

        </div>
        <FooterSiteOfficiel />
      </main>
  );
}
